enum AuthActionTypes {
  REQUEST_LOGIN         = 'Auth/REQUEST_LOGIN',
  REQUEST_LOGIN_SUCCESS = 'Auth/REQUEST_LOGIN_SUCCESS',
  REQUEST_LOGIN_FAILURE = 'Auth/REQUEST_LOGIN_FAILURE',

  SET_IS_LOGGED = 'Auth/SET_IS_LOGGED',

  LOGOUT = 'Auth/LOGOUT',
}

export default AuthActionTypes
